module.exports = __webpack_public_path__ + "img/bus-distance.6a609a40.png";